export class HTMLSelectItem {
	id: number | string;
	value: string;

	constructor(id: number | string, value: string) {
		this.id = id;
		this.value = value;
	}
}
